import React from 'react';

function Star({
  isActive,
  onClick,
  setIsHovered,
  step,
}: {
  isActive: boolean;
  onClick: (rating: number) => void;
  setIsHovered?: (isHovered: boolean, rating: number) => void;
  step: number;
}): React.JSX.Element {
  return (
    <button
      className={`star${isActive ? ' active' : ''}`}
      onMouseEnter={(): void =>
        setIsHovered ? setIsHovered(true, step) : undefined
      }
      onMouseLeave={(): void =>
        setIsHovered ? setIsHovered(false, step) : undefined
      }
      onClick={(): void => onClick(step)}
      type="button"
      aria-label={`Rate ${step} out of 5`}
      aria-pressed={isActive}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    </button>
  );
}

export default Star;
